import { render, staticRenderFns } from "./questionMarkTooltip.vue?vue&type=template&id=489ef2ec&"
import script from "./questionMarkTooltip.vue?vue&type=script&lang=ts&setup=true&"
export * from "./questionMarkTooltip.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports